import { Box, Button, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Container, Paper, Typography, Grid } from "@mui/material";
import React from "react";
import Assignment from "../components/Assignments/Assignment";
import Student from "../components/Student/Student";
import NewAssignmentModal from "../components/Assignments/NewAssignmentModal";
import { useUser } from "../globals/UserContext";
import { useClass } from "../globals/ClassContext";
import ClassCodeModal from "../components/Modals/ClassCodeModal/ClassCodeModal";
import ConfirmationModal from "../components/Modals/ConfirmationModal/ConfirmationModal";
import AdminOverview from "../components/AdminOverview/AdminOverview";
import AdminGrades from "../components/ClassInfo/Grades/AdminGrades";

export default function AdminInfo({ setPage }) {
  const user = useUser();
  const classroom = useClass();

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [showClassCode, setShowClassCode] = React.useState(false);
  const handleShowClassCode = () => setShowClassCode(true);
  const handleHideClassCode = () => setShowClassCode(false);

  const [confirmationModalOpen, setConfirmationModalOpen] =
    React.useState(false);
  const handleConfirmationOpen = () => setConfirmationModalOpen(true);
  const handleConfirmationClose = () => setConfirmationModalOpen(false);

  const e = () => {
    console.log("No confirmation effect.");
  };

  const [confirmationEffect, setConfirmationEffect] = React.useState(e);

  const [confirmationText, setConfirmationText] = React.useState("");

  return (
    <Grid
      container
      spacing={2}
      direction="column"
      maxWidth="70rem"
      margin="auto"
      sx={{ paddingTop: "80px" }}
    >
      <Grid container sx={{ marginBottom: "20px" }}>
        <Typography variant="h3" sx={{ margin: "5px 0px", flex: "3" }}>
          {classroom.name}
        </Typography>
        <Button
          variant="contained"
          sx={{ flex: "1" }}
          onClick={handleShowClassCode}
        >
          Show Class Code
        </Button>
        <ClassCodeModal
          classroom={classroom}
          open={showClassCode}
          setOpen={setShowClassCode}
          handleClose={handleHideClassCode}
        ></ClassCodeModal>
      </Grid>

      <Grid container direction="row">
        <Container sx={{ marginBottom: "40px", flex: "1" }}>
          <Grid container>
            <Typography variant="h4" sx={{ margin: "5px 0px" }}>
              Assignments
            </Typography>
            <IconButton
              onClick={handleOpen}
              sx={{ height: "40px", alignSelf: "center" }}
            >
              <AddIcon />
            </IconButton>
            <NewAssignmentModal
              setPage={setPage}
              open={open}
              setOpen={setOpen}
              handleClose={handleClose}
              user={user}
              classroom={classroom}
            ></NewAssignmentModal>
          </Grid>
          <Box
            sx={{ maxHeight: "500px", overflow: "auto", padding: "10px 0px" }}
          >
            <Grid
              container
              spacing={1}
              alignContent="flex-start"
              justifyContent="flex-start"
              direction="column"
            >
              {classroom?.assignments?.map((assignmentID) => (
                <Assignment
                  key={assignmentID}
                  assignmentID={assignmentID}
                  classID={classroom._id}
                  setPage={setPage}
                  handleConfirmationOpen={handleConfirmationOpen}
                  setConfirmationEffect={setConfirmationEffect}
                  setConfirmationText={setConfirmationText}
                ></Assignment>
              ))}
            </Grid>
          </Box>
        </Container>

        <Container sx={{ flex: "1" }}>
          <Grid direction="row" container>
            <Typography variant="h4" sx={{ margin: "5px 0px", flex: "1" }}>
              Students
            </Typography>
          </Grid>
          <Box
            sx={{ maxHeight: "500px", overflow: "auto", padding: "10px 0px" }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="flex-start"
              alignContent="flex-start"
              direction="column"
            >
              {classroom?.students?.map((studentID) => (
                <Student
                  key={studentID}
                  studentID={studentID}
                  handleConfirmationOpen={handleConfirmationOpen}
                  setConfirmationEffect={setConfirmationEffect}
                  setConfirmationText={setConfirmationText}
                ></Student>
              ))}
            </Grid>
          </Box>
        </Container>
      </Grid>
      <Container sx={{ marginBottom: "40px" }}>
        <Typography variant="h4" sx={{ margin: "5px 0px" }}>
          Student Grades
        </Typography>
        <AdminGrades setPage={setPage}></AdminGrades>
      </Container>
      <Container sx={{ marginBottom: "40px" }}>
        <Typography variant="h4" sx={{ margin: "5px 0px" }}>
          Submission Overview
        </Typography>
        <AdminOverview setPage={setPage} />
      </Container>

      <ConfirmationModal
        open={confirmationModalOpen}
        notification={confirmationText}
        onSubmit={confirmationEffect}
        handleClose={handleConfirmationClose}
      ></ConfirmationModal>
    </Grid>
  );
}
